module.exports = __webpack_public_path__ + "img/file_instructions.abeea075.png";